module.exports = __webpack_public_path__ + "static/media/29n.1470904b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/29n.svg
// module id = 176
// module chunks = 0